import type { z } from "zod";
import { createContext, useContext } from "react";
import type { createLegalSchema } from "@/schemas/legal/legal";

interface LegalContextType {
    onComplete: (data: z.infer<typeof createLegalSchema>) => void,
    isFetching: boolean,
}

export const LegalContext = createContext<LegalContextType | null>(null);

export const useLegalContext = () => {
    const context = useContext(LegalContext);
    if (!context) {
        throw new Error("useLegalContext must be used within a LegalContextProvider");
    }
    return context;
}